/**
 * Calculates initials from provided arguments
 * e.g. ['Peter', 'Hanson'] -> 'PH'
 */
const reduceToInitials = (...names) => {
  const nameParts = names
    .map((name) => name.split(" "))
    .reduce((mem, parts) => mem.concat(parts), [])
    // Removed parts that are empty space or contains illegal characters
    // e.g. '(' in (ADMIN)
    .filter((part) => !/[\(\#]/g.test(part) && part !== "");

  if (nameParts.length > 1) {
    return (
      nameParts[0][0].toUpperCase() +
      nameParts[nameParts.length - 1][0].toUpperCase()
    );
  } else if (nameParts.length > 0) {
    return nameParts[0][0].toUpperCase();
  } else {
    return "";
  }
};

export default reduceToInitials;
